import type { ThemeWithoutTokens } from '../theme.types';

export const dividerTokens = (theme: ThemeWithoutTokens) =>
  ({
    dividerSize: '1px',
    dividerColor: theme.colors.border,
  }) as const;
